import { getAdoptabobblesBoughtWidgetConfig } from '../../UserWidgets/AdoptabobblesBought/widgetConfig';

export const getAdoptabobblesWidgetConfigs = ({ t, dispatch }) =>
  ({
    adoptabobblesBought: getAdoptabobblesBoughtWidgetConfig({ t, dispatch }),
  }) as any;

export default getAdoptabobblesWidgetConfigs;
